module.exports = __webpack_public_path__ + "static/media/item4.febb2e11.jpg";